<ui-card>
    <div class="margin-bottom-2">
        <div class="flex justify-space-between">
            <h2>{{ 'applicant-tracker.components.consentCard.title' | translate }}</h2>
            <ui-button
                *ngIf="jobPosting.id"
                [attr.data-cy]="'saveConsent'"
                type="outline"
                (click)="onSaveConsentForm()"
                >{{ 'save' | translate }}</ui-button
            >
        </div>
    </div>
    <app-job-posting-consent-form #applicantConsentForm [jobPosting]="jobPosting"></app-job-posting-consent-form>
</ui-card>
